(() => {
  function getVariantIdFromUrl() {
    const params = new URLSearchParams(window.location.search);
    return params.get('v') || params.get('variant');
  }

  function getVariantData() {
    return window.__productVariants || [];
  }

  function syncSectionVariantPickerFromUrl(sectionEl) {
    if (!sectionEl) return;

    const sectionId = sectionEl.getAttribute('data-section');
    if (!sectionId) return;

    const variantIdFromUrl = getVariantIdFromUrl();
    if (!variantIdFromUrl) return;

    const variants = getVariantData();
    if (!variants || variants.length === 0) return;

    const targetVariant = variants.find(
      (variant) => variant.id.toString() === variantIdFromUrl.toString()
    );
    if (!targetVariant) return;

    const variantPicker = sectionEl.querySelector(
      `variant-radios[data-section="${sectionId}"], variant-selects[data-section="${sectionId}"]`
    );
    if (!variantPicker) return;

    function attemptSync(attemptsLeft) {
      const isUpgraded = typeof variantPicker.onVariantChange === 'function';

      if (!isUpgraded) {
        if (attemptsLeft > 0) {
          setTimeout(() => attemptSync(attemptsLeft - 1), 100);
        }
        return;
      }

      const pickerTag = variantPicker.tagName.toLowerCase();
      let didChange = false;

      if (pickerTag === 'variant-radios') {
        const fieldsets = Array.from(variantPicker.querySelectorAll('fieldset'));
        targetVariant.options.forEach((targetValue, index) => {
          const fieldset = fieldsets[index];
          if (!fieldset) return;
          const radios = Array.from(fieldset.querySelectorAll('input[type="radio"]'));
          const radioToCheck = radios.find((radio) => radio.value === targetValue);
          if (radioToCheck && !radioToCheck.checked) {
            radioToCheck.checked = true;
            didChange = true;
          }
        });
      } else if (pickerTag === 'variant-selects') {
        const selects = Array.from(variantPicker.querySelectorAll('select'));
        targetVariant.options.forEach((targetValue, index) => {
          const select = selects[index];
          if (!select) return;
          const matchingOption = Array.from(select.options).find(
            (option) => option.value === targetValue
          );
          if (matchingOption && select.value !== matchingOption.value) {
            select.value = matchingOption.value;
            didChange = true;
          }
        });
      }

      if (didChange) {
        // Call the same method manual button clicks trigger - unifies both code paths
        variantPicker.onVariantChange();
      }
    }

    attemptSync(10); // up to ~1 second of retries at 100ms intervals
  }

  function init() {
    const sections = document.querySelectorAll('[id^="MainProduct-"][data-section]');
    sections.forEach(syncSectionVariantPickerFromUrl);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    setTimeout(init, 0); // defer one tick so custom elements can upgrade
  }

  document.addEventListener('shopify:section:load', (event) => {
    const directMatch =
      event.target &&
      event.target.matches &&
      event.target.matches('[id^="MainProduct-"][data-section]');
    const sectionEl = directMatch
      ? event.target
      : event.target && event.target.querySelector
      ? event.target.querySelector('[id^="MainProduct-"][data-section]')
      : null;

    if (sectionEl) syncSectionVariantPickerFromUrl(sectionEl);
  });
})();
